var AET_Animation = function () {
    var self = this;
    var $ = jQuery;

    self.delete = function ($el) {
        var dfd = $.Deferred();
        if($.browser.msie && parseInt($.browser.version, 10) <= 9){
            $el.remove();
            dfd.resolve();
        }else{
            $el.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(e) {
                dfd.resolve();
                $el.remove();
            }).addClass('removed-item');
        }
        return dfd;
    };

    self.delete_model = function ($el, model_name) {
        var panel = $('#panel-' + model_name + 's');

        self.delete($el);

        // show notice 'No models found'
        setTimeout(function () {
            var count = $('#' + model_name + 's-list > li').length;
            if(count === 0) {
                var notice = panel.find('.empty-model');
                notice.css('display', 'block').addClass('at-transition');
                setTimeout(function () {
                    notice.css('visibility', 'visible')
                        .css('opacity', '1');
                }, 1);
                // update models count in panel heading
                panel.find('.panel-heading span').remove();
                return;
            }
            panel.find('> .panel-heading span').html('(' + count +')');
        }, 500);
    };
};